import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8089'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor — add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

export const mcpApi = {
  // OAuth client management
  createClient: (name) => api.post('/mcp/oauth/clients', {
    name,
    redirect_uris: [
      'https://claude.ai/api/mcp/auth_callback',
      'https://api.anthropic.com/mcp/oauth/callback',
      'http://localhost',
      'http://127.0.0.1',
    ],
  }),
  getClients: () => api.get('/mcp/oauth/clients'),
  revokeClient: (clientId) => api.delete(`/mcp/oauth/clients/${clientId}`),
  permanentlyDeleteClient: (clientId) => api.delete(`/mcp/oauth/clients/${clientId}/permanent`),

  // Initialize MCP session on a specific domain (e.g., ngrok) for OAuth consent flow
  initSession: (ngrokUrl) => axios.get(`${ngrokUrl}/mcp/oauth/init-session`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
    withCredentials: true,
  }),

  // Metadata (for diagnostics)
  getProtectedResourceMetadata: () => api.get('/.well-known/oauth-protected-resource'),
  getAuthorizationServerMetadata: () => api.get('/.well-known/oauth-authorization-server'),

  // Audit / diagnostics
  getAuditEvents: (limit = 50) => api.get('/mcp/oauth/audit', { params: { limit } }),
}

export default mcpApi
